import React, { useState } from "react";
import { Button } from "../../../components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../../components/ui/dialog";

import { Label } from "../../../components/ui/label";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "../../../components/ui/select";
import apiClient from "../../../utils/apiClient";
import { Edit2Icon } from "lucide-react";

export function EditCallPutModal({
  symbol,
  call,
  put,
  setCallValue,
  setPutValue,
  handleUpdateCallPutValue,
}) {
  const [open, setOpen] = useState(false);
  
  const callPutOptionsList = [
    { value: 1, title: "1" },
    { value: 0, title: "0" },
  ];

  const [newCallValue, setNewCallValue] = useState(call);
  const [newPutValue, setNewPutValue] = useState(put);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button className="bg-zinc-800 text-white px-2.5 hover:bg-zinc-700  rounded-[5px]">
          <Edit2Icon className="w-4 h-4 " />
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[525px] border-zinc-700">
        <DialogHeader>
          <DialogTitle className="text-white">Edit Call PUT Values for {symbol}</DialogTitle>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="grid grid-cols-1 items-center gap-4">
            <Label className=" text-white">CE</Label>
            <Select
              value={newCallValue}
              onValueChange={(value) => setNewCallValue(value)}
            >
              <SelectTrigger className=" text-white text-[15px] hover:bg-zinc-800">
                <SelectValue placeholder="Is Call Active" className="" />
              </SelectTrigger>
              <SelectContent className="border-zinc-700">
                <SelectGroup>
                  {callPutOptionsList.map((item) => (
                    <SelectItem key={item.value} value={item.value}>
                      {item.title}
                    </SelectItem>
                  ))}
                </SelectGroup>
              </SelectContent>
            </Select>
          </div>
          <div className="grid grid-cols-1 items-center gap-4">
            <Label className=" text-white">PUT</Label>
            <Select
              value={newPutValue}
              onValueChange={(value) => setNewPutValue(value)}
            >
              <SelectTrigger className=" text-white text-[15px] hover:bg-zinc-800">
                <SelectValue placeholder="Is Put Active" className="" />
              </SelectTrigger>
              <SelectContent className="border-zinc-700">
                <SelectGroup>
                  {callPutOptionsList.map((item) => (
                    <SelectItem key={item.value} value={item.value}>
                      {item.title}
                    </SelectItem>
                  ))}
                </SelectGroup>
              </SelectContent>
            </Select>
          </div>
        </div>
        <DialogFooter>
          <Button
            type="submit"
            className="text-[16px] font-normal bg-zinc-800 text-white hover:bg-zinc-700"
            onClick={() => handleUpdateCallPutValue(symbol,newCallValue, newPutValue)}
          >
            Update
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
